module.exports = {
	hash: require('./lib/scrypt-async'),
	hashSync: require('./lib/scrypt-sync')
}